import { Styles, dividerClasses, generateClasses, linkClasses, netlineAppHeaderClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const appHeaderClasses = generateClasses('AppFrameAppHeader', [
  'root',
  'productsMenu',
  'main',
  'logoImage',
] as const);

export const appHeaderMainClassess = generateClasses(appHeaderClasses.main, ['hidden'] as const, true);

const styles: Styles = ({ theme, theme: { palette } }) => {
  const {
    appHeader: {
      hidden,
      backgroundColor: appHeaderBackgroundColor,
      dividerColor,
      appHeaderHeight,
      dividerNextToCustomerLogoHeight,
      elementHoverBackgroundColor,
      productsMenu: {
        iconColor: productsMenuIconColor,
        backgroundColor: productsMenuBackgroundColor,
        hoverBackgroundColor: productsMenuHoverColor,
      },
      customerLogo: {
        logoHeight: customerLogoHeight,
        leftPadding: customerLogoLeftPadding,
        rightPadding: customerLogoRightPadding,
        hideCustomerLogo,
      },
    },
  } = getAppFrameTheme(theme);

  return {
    [`&.${appHeaderClasses.root} .${appHeaderClasses.main}`]: {
      ...(hidden ? { display: 'none' } : {}),
      height: appHeaderHeight,
      paddingLeft: 0,
      paddingRight: 0,
      background: appHeaderBackgroundColor,
      transition: 'height 0.3s',
      overflow: 'hidden',
      [`&.${appHeaderMainClassess.hidden}`]: {
        height: 0,
      },

      [`.${netlineAppHeaderClasses.logo}`]: {
        display: hideCustomerLogo ? 'none' : 'inline',
        paddingLeft: customerLogoLeftPadding,
        paddingRight: customerLogoRightPadding,
        height: customerLogoHeight ?? 28,
        objectFit: 'contain',
        objectPosition: 'left',
        width: 'auto',
      },
      [`.${netlineAppHeaderClasses.menuIcon}`]: {
        borderRadius: 0,
        height: appHeaderHeight,
        width: 48,
        outlineColor: palette.primary[800],
        outlineOffset: -2,
        marginLeft: 0,
        background: productsMenuBackgroundColor,
        color: productsMenuIconColor,

        '&:hover': {
          background: productsMenuHoverColor ?? elementHoverBackgroundColor,
        },
      },

      [`.${netlineAppHeaderClasses.section}`]: {
        [`.${linkClasses.root}`]: {
          '&:focus': {
            outline: `${palette.primary[800]} solid 1px}`,
            outlineOffset: 2,
          },
        },

        [`.${dividerClasses.root}`]: {
          display: hideCustomerLogo ? 'none' : '',
          background: dividerColor,
          marginLeft: 32,
          height: dividerNextToCustomerLogoHeight,
        },

        '& > h6': {
          flex: 1,
        },
      },
      [`.${netlineAppHeaderClasses.center} .${netlineAppHeaderClasses.title}`]: {
        height: appHeaderHeight,
        lineHeight: `${appHeaderHeight}`.endsWith('px') ? appHeaderHeight : `${appHeaderHeight}px`,
      },
    },
  };
};

export default styles;
